/**
 * Demo 示例 接口操作类
 *
 * @module DemoAPI
 * @since 1.0.0
 * @version 1.0.0
 */

import http from './http'

/**
 * @class WuYingAPI
 */
export default class WuYingAPI {
  static applyService() {
    return http.post({
      url: `base/v1/chargeFunctionOrders`,
      data: { chargeFunctionId: '1311215676777648141' },
      headers: {
        appCode: 'saas_web',
      },
    })
  }

  static searchChargeFunctionOrders(options = {}) {
    return http.post({
      url: `/operation/v1/chargeFunctionOrders/search`,
      headers: {
        appCode: 'saas_web',
      },
      data: {
        ...options,
      },
    })
  }

  static enableChargeFunction(options = {}) {
    return http.put({
      url: `/base/v1/chargeFunction/enable`,
      headers: {
        appCode: 'saas_web',
      },
      data: {
        ...options,
      },
    })
  }

  static getAIStoragePhone(options) {
    return http.get({
      params: {
        ...options,
      },
      url: `/base/v1/cloud/computer/getAIStoragePhone`,
      headers: {
        appCode: 'saas_web',
      },
    })
  }
  static setAIStoragePhone(options = {}) {
    return http.post({
      url: `/base/v1/cloud/computer/setAIStoragePhone`,
      headers: {
        appCode: 'saas_web',
      },
      data: {
        ...options,
      },
    })
  }
}
